<template>
  <div class="container">
    <p class="disable-selection">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: "CustomLink",
  props: {
    label: String,
    labelGtm: String,
    analyticsName: {
      type: String,
      default: null
    }
  },
  computed: {
    gtmLabel() {
      if (this.labelGtm) {
        return this.labelGtm;
      }

      let parent = this.$parent;
      let ignoreComponents = ["Container", "FormValidator"];
      while (parent && ignoreComponents.indexOf(parent.$options.name) !== -1) {
        parent = parent.$parent;
      }

      return `${parent.$options.name}.${this.label}`;
    }
  }
};
</script>

<style scoped>
p {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #1464a5;
  text-decoration: none;
  cursor: pointer;
  margin: 0;
}

.container {
  display: inline-block;
}
</style>
